'use client'
import { useTranslation } from '@/app/i18n/client'
import { Button } from '@/components/ui/button'
import { Switch } from '@/components/ui/switch'
import { useCookieContext } from '../../(Contexts)/CookieContextProvider'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import { useParams } from 'next/navigation'
import { useState } from 'react'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import {
  RECAPTCHA_COOKIES_DETAILS,
  STATISTICS_COOKIES_DETAILS,
} from '@/app/utils/cookiesConsent'
import CookieToggle from './ToggleCookie'
import Link from 'next/link'

const CookieModal = () => {
  const { showDetailedView, isModalOpen } = useCookieContext()
  return (
    isModalOpen && (
      <div className="fixed bottom-0 right-0 bg-[#ffffff]  p-5 w-[500px] mobile:w-[360px] z-[10] mb-[10px] flex flex-col gap-4 shadow-[0_10px_46px_0_rgba(85,85,85,0.16)] ">
        {showDetailedView ? <ManageCookiePrefernce /> : <CookiePreference />}
      </div>
    )
  )
}

export default CookieModal

const CookiePreference = () => {
  const { t } = useTranslation()
  const {
    postCookies,
    setIsModalOpen,
    setShowDetailedView,
    setCookiePreferences,
  } = useCookieContext()

  const handleAllowAll = () => {
    setCookiePreferences({ necessary: true, thirdParty: true, recaptcha: true })
    postCookies({ thirdParty: true, recaptcha: true })
  }

  return (
    <>
      <span className=" flex">
        <p className="text-base font-[500] not-italic leading-[normal] tracking-[normal] text-left text-black">
          {t('Cookies Preference Center')}
        </p>

        <span className=" ml-auto">
          <span
            className=" cursor-pointer"
            onClick={() => {
              setIsModalOpen(false)
            }}
          ></span>
        </span>
      </span>
      <p className=" text-sm font-normal not-italic leading-[1.86] tracking-[0.04px] text-left text-[#8b8b8b]">
        {t(
          'This website uses cookies to enhance your browsing experience, personalize content and advertisements, provide social media features, and analyze our traffic. We may also share information about your use of our site with our social media, advertising, and analytics partners. These partners may combine it with other information you’ve provided to them or that they’ve collected from your use of their services.'
        )}
      </p>
      <span className=" flex w-[70%]  gap-3 ">
        <Button variant="secondary" size="sx" onClick={handleAllowAll}>
          {t('ALLOW ALL')}
        </Button>
        <Button
          variant="outline"
          size="sx"
          onClick={() => {
            setShowDetailedView(true)
          }}
        >
          {t('MANAGE')}
        </Button>
      </span>
    </>
  )
}

const ManageCookiePrefernce = () => {
  const {
    setCookiePreferences,
    setIsNecessarySectionExpanded,
    setIsThirdPartySectionExpanded,
    postCookies,
    setIsRecaptchaSectionExpanded,
    cookiePreferences,
    showDetailedView,
    isModalOpen,
    isNecessarySectionExpanded,
    isThirdPartySectionExpanded,
    isRecaptchaSectionExpanded,
  } = useCookieContext()
  const params = useParams()
  const { t } = useTranslation()
  const toggleNecessaryCookies = () =>
    setIsNecessarySectionExpanded(!isNecessarySectionExpanded)

  const toggleThirdPartyCookies = () =>
    setIsThirdPartySectionExpanded(!isThirdPartySectionExpanded)

  const toggleReCaptchaCookies = () =>
    setIsRecaptchaSectionExpanded(!isRecaptchaSectionExpanded)

  const handleCookieAcceptAll = () => {
    // note: set State of all cookies needs to be enabled
    setCookiePreferences((prev) => ({
      ...prev,
      thirdParty: true,
      recaptcha: true,
    }))

    postCookies({ thirdParty: true, recaptcha: true })
  }

  const handleCookieAcceptSelection = () => {
    if (activeTab === 'details') {
      postCookies({
        thirdParty: cookiePreferences?.thirdParty,
        recaptcha: cookiePreferences?.recaptcha,
      })
      return
    }
    setActiveTab('details')
  }
  const handleCookieDecline = () => {
    // note: set State for all cookies needs to be declined
    setCookiePreferences((prev) => ({
      ...prev,
      thirdParty: false,
      recaptcha: false,
    }))

    postCookies({ thirdParty: false, recaptcha: false })
  }
  const handleCookieDeclaration = () => {
    setActiveTab('details')
  }

  const tabs = ['consent', 'details', 'about']
  const [activeTab, setActiveTab] = useState(tabs[0])

  return (
    <>
      <Dialog open={isModalOpen && showDetailedView} fullWidth maxWidth={'md'}>
        <DialogContent
          className="w-full relative"
          sx={{ padding: 0, paddingBottom: 2 }}
        >
          <div className="relative w-full  bg-[#FAFAFA] flex justify-center mb-2">
            <div className="relative flex    items-center w-full justify-between">
              {tabs.map((tab) => {
                const selected = activeTab === tab

                return (
                  <button
                    key={tab}
                    onClick={() => setActiveTab(tab)}
                    className={`relative py-3 w-full capitalize text-[18px]  font-medium transition-all duration-300 ease-in-out
              ${
                selected
                  ? 'text-[#DF7D2F] bg-[#FEE7D1] font-ns_bold'
                  : 'text-gray-500 hover:text-[#DF7D2F]'
              }`}
                  >
                    {t(tab)}
                    {selected && (
                      <span className="absolute left-0 bottom-0 h-[2px] w-full bg-[#DF7D2F] rounded-full transition-all duration-300 ease-in-out" />
                    )}
                  </button>
                )
              })}
            </div>
          </div>
          {/* Scrollable content area */}
          <div
            className="overflow-y-auto flex-grow"
            style={{ maxHeight: 'calc(80vh - 120px)' }}
          >
            {activeTab === 'details' && (
              <div className="flex overflow-y-auto flex-col px-[20px] py-2 gap-4">
                {/* Necessary Cookies */}
                <div id="necessary-cookies" className=" ">
                  <h4 className="font-semibold text-[16px] capitalize mb-2">
                    {t('Operational Cookies')}
                  </h4>
                  <CookieToggle
                    title={t('Necessary Cookies')}
                    isOpen={true}
                    onToggle={toggleNecessaryCookies}
                    description={t(
                      'This cookies enable core website functions. They cannot be disabled as they are required for our website to work properly. This information might be about you, your preferences, or your device and is mostly used to make the site work as you expect it to.'
                    )}
                    additionalContent={
                      <span className="ml-auto flex pr-2 items-center">
                        <Switch
                          checked={cookiePreferences.necessary}
                          disabled
                        />
                      </span>
                    }
                    needToogle={false}
                  />
                </div>

                {/* Third Party Cookies */}
                <div id="third-party-cookies" className="pt-2">
                  <h4 className="font-semibold text-[16px] capitalize mb-2">
                    {t('Third Party Cookies')}
                  </h4>
                  <CookieToggle
                    title={t('Statistics')}
                    isOpen={isThirdPartySectionExpanded}
                    onToggle={toggleThirdPartyCookies}
                    description={t(
                      'These cookies allow us or our third-party analytics providers to collect information and statistics on use of our services by you and other visitors. This information helps us to improve our services and products for the benefit of you and others.'
                    )}
                    additionalContent={
                      <span className="ml-auto pr-2 flex items-center">
                        <Switch
                          checked={cookiePreferences.thirdParty}
                          onClick={() =>
                            setCookiePreferences((prev) => ({
                              ...prev,
                              thirdParty: !prev.thirdParty,
                            }))
                          }
                        />
                      </span>
                    }
                    SubCookieDetails={STATISTICS_COOKIES_DETAILS}
                  />
                  <CookieToggle
                    title={t('Recaptcha')}
                    isOpen={isRecaptchaSectionExpanded}
                    onToggle={toggleReCaptchaCookies}
                    description={t(
                      'These cookies help us distinguish between human users and bots by enabling Google reCAPTCHA. This service protects our site from spam and abuse by using advanced risk analysis techniques to determine whether a user is human, ensuring a safer and more secure experience for everyone.'
                    )}
                    additionalContent={
                      <span className="ml-auto pr-2 flex items-center">
                        <Switch
                          checked={cookiePreferences.recaptcha}
                          onClick={() =>
                            setCookiePreferences((prev) => ({
                              ...prev,
                              recaptcha: !prev.recaptcha,
                            }))
                          }
                        />
                      </span>
                    }
                    SubCookieDetails={RECAPTCHA_COOKIES_DETAILS}
                  />
                </div>
                <div id="third-party-cookies" className=""></div>
              </div>
            )}

            {activeTab == 'consent' && (
              <div className="px-5 overflow-y-auto flex flex-col gap-3 pb-2 pt-4">
                <h3 className="font-ns_semibold text-base">
                  {t('This Website uses Cookies')}
                </h3>

                <p className="text-[15px] font-normal not-italic leading-[1.86] tracking-[0.04px] text-left text-[#6b6b6b] ">
                  {t(
                    'This website uses cookies to enhance your browsing experience, personalize content and advertisements, provide social media features, and analyze our traffic. We may also share information about your use of our site with our social media, advertising, and analytics partners. These partners may combine it with other information you’ve provided to them or that they’ve collected from your use of their services.'
                  )}
                </p>
              </div>
            )}

            {activeTab == 'about' && (
              <div className="p-5 overflow-y-auto flex flex-col gap-4 text-[#6b6b6b]">
                <p>
                  {t(
                    "Cookies are small text files that can be used by websites to make a user's experience more efficient."
                  )}
                </p>
                <p>
                  {t(
                    'The law states that we can store cookies on your device if they are strictly necessary for the operation of this site. For all other types of cookies we need your permission. This means that cookies which are categorized as necessary, are processed based on GDPR Art. 6 (1) (f). All other cookies, meaning those from the categories preferences and marketing, are processed based on GDPR Art. 6 (1) (a) GDPR.'
                  )}
                </p>
                <p>
                  {t(
                    'This site uses different types of cookies. Some cookies are placed by third party services that appear on our pages.'
                  )}
                </p>
                <p>
                  {t(
                    'You can at any time change or withdraw your consent from the'
                  )}{' '}
                  <span
                    className="text-blue-600 hover:underline cursor-pointer"
                    onClick={handleCookieDeclaration}
                  >
                    {t(`Cookie Declaration`)}
                  </span>{' '}
                  {t('on our website.')}
                </p>
                <p>
                  {t(
                    'Learn more about who we are, how you can contact us and how we process personal data in our'
                  )}{' '}
                  <Link
                    href={`/${params.lng}/privacy_policy`}
                    rel="noopener noreferrer"
                    target="_blank"
                    className="text-blue-600 hover:underline cursor-pointer"
                  >
                    {t('Privacy Policy')}
                  </Link>
                  .
                </p>
                <p>
                  {t(
                    'Please state your consent ID and date when you contact us regarding your consent.'
                  )}
                </p>
              </div>
            )}
          </div>

          <div className="sticky  left-0 right-0 bg-white gap-3 py-3 px-5 flex items-center justify-center border-t-2 w-full mt-auto">
            <Button variant="outline" size="sx" onClick={handleCookieDecline}>
              {t('DENY')}
            </Button>
            <Button
              variant="secondary"
              size="sx"
              onClick={handleCookieAcceptSelection}
              className="uppercase"
            >
              {activeTab === 'details' ? (
                t('ALLOW SELECTION')
              ) : (
                <span className="flex text-white items-center gap-1">
                  {` ${t('customize')}`}
                  <NavigateNextIcon fontSize="small" />
                </span>
              )}
            </Button>
            <Button
              variant="secondary"
              size="sx"
              onClick={handleCookieAcceptAll}
            >
              {t('ALLOW ALL')}
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  )
}
